
/* Single image */
import img1 from '../images/icon/engineering.jpeg'
import img2 from '../images/icon/oil-refinery.jpeg'
import img3 from '../images/icon/turbo.jpeg'
import img4 from '../images/icon/timing.jpeg'
import img5 from '../images/icon/recycle-water.jpeg'
import img6 from '../images/icon/excavator.jpeg'

import imgD1 from '../images/icon/dark/engineering.svg'
import imgD2 from '../images/icon/dark/oil-refinery.svg'
import imgD3 from '../images/icon/dark/turbo.svg'
import imgD4 from '../images/icon/dark/timing.svg'
import imgD5 from '../images/icon/dark/recycle-water.svg'
import imgD6 from '../images/icon/dark/excavator.svg'



const Simg1 = 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80'
const Simg2 = 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80'
const Simg3 = 'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=800&q=80'
const Simg4 = 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80'
const Simg5 = 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80'
const Simg6 = 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80'

const Services = [
    {
        id: 1,
        image: img1,
        imageDrak: imgD1,
        icon: 'tabler:door',
        simag: Simg1,
        subtitle: 'Menuiserie',
        title: 'Portes en aluminium',
        description: 'Nous concevons et installons des portes en aluminium alliant robustesse, design moderne et excellente isolation pour sécuriser et valoriser votre entree.',
        slug: 'Portes-Aluminium'
    },
    {
        id: 2,
        image: img2,
        imageDrak: imgD2,
        icon: 'tabler:window',
        simag: Simg2,
        subtitle: 'Ouvertures',
        title: 'Fenetres en aluminium',
        description: 'Nos fenetres en aluminium offrent une isolation thermique et acoustique optimale, tout en apportant une touche contemporaine a vos espaces.',
        slug: 'Fenetres-Aluminium'
    },
    {
        id: 3,
        image: img3,
        imageDrak: imgD3,
        icon: 'tabler:building-arch',
        simag: Simg3,
        subtitle: 'Facade',
        title: 'Alucobond (habillage de facade)',
        description: 'Nous realisons des revetements en Alucobond pour donner a vos batiments une finition esthetique, resistante et adaptee aux architectures modernes.',
        slug: 'Alucobond-Facade'
    },
    {
        id: 4,
        image: img4,
        imageDrak: imgD4,
        icon: 'tabler:fence',
        simag: Simg4,
        subtitle: 'Securite',
        title: 'Garde-corps',
        description: 'Nos garde-corps en aluminium assurent votre securite tout en apportant une finition elegante a vos balcons, terrasses et escaliers.',
        slug: 'Garde-Corps'
    },
    {
        id: 5,
        image: img5,
        imageDrak: imgD5,
        icon: 'tabler:columns-3',
        simag: Simg5,
        subtitle: 'Architecture',
        title: 'Murs-rideaux',
        description: 'Nous concevons des murs-rideaux en aluminium qui combinent performance, luminosite et design contemporain pour les batiments professionnels.',
        slug: 'Murs-Rideaux'
    },
    {
        id: 6,
        image: img6,
        imageDrak: imgD6,
        icon: 'tabler:arrow-autofit-height',
        simag: Simg6,
        subtitle: 'Protection',
        title: 'Volets roulants',
        description: 'Nous installons des volets roulants en aluminium pratiques et resistants, offrant une protection optimale et une gestion facile de la lumiere et de l\'intimite.',
        slug: 'Volets-Roulants'
    }




];
export default Services;